import { EAuthModalPage } from '@/store/types';
import { JsonWebTokenType } from '@/utils/token-manager';
import { createSliceSteamup } from '../common';

export type ConfirmCodeType = 'email' | 'social' | 'pwreset';
interface IAuthModalState {
  currentPage: EAuthModalPage;
  email: string;
  token: JsonWebTokenType;
  confirmCodeType: ConfirmCodeType;
  deletedAt: Date | null;

  register: 'general' | 'creator';
  belong: string;
  phone: string;
  actualName: string;
  name: string;
  password: string;
  policy: boolean;

  onSuccess: undefined | Function;
  onClose: undefined | Function;
  gotoAuthRegister: undefined | Function;
  gotoAuthLogin: undefined | Function;
  gotoAuthReset: undefined | Function;

  pageType: undefined |'reset'
}

const initialState = {
  currentPage: EAuthModalPage.INPUT_EMAIL,
  confirmCodeType: 'email',
  token: { at: '', rt: '' },
  deletedAt: null,
  onSuccess: () => {},
  onClose: () => {},
  gotoAuthRegister: () => {},
  gotoAuthLogin: () => {},
  gotoAuthReset: () => {},
  pageType: undefined,
  email: '',

  belong: '',
  actualName: '',
  phone: '',
  name: '',
  password: '',
  register: 'general',
  policy: false, /** 동의여부 */
} as IAuthModalState;

const authModalSlice = createSliceSteamup(
  'authModal',
  initialState,
  {
    init(state) {
      state.currentPage = initialState.currentPage;
      state.email = initialState.email;
      state.confirmCodeType = initialState.confirmCodeType;
      state.token = initialState.token;
      state.deletedAt = null;

      state.register = initialState.register;
      state.belong = initialState.belong;
      state.phone = initialState.phone;
      state.actualName = initialState.actualName;
      state.name = initialState.name;
      state.password = initialState.password;
      state.policy = initialState.policy;
    },
  },
);

export default authModalSlice;
